"use strict";
var ApiPackageAvailability;
(function (ApiPackageAvailability) {
    ApiPackageAvailability[ApiPackageAvailability["Domestic"] = 0] = "Domestic";
    ApiPackageAvailability[ApiPackageAvailability["International"] = 1] = "International";
    ApiPackageAvailability[ApiPackageAvailability["Both"] = 2] = "Both";
})(ApiPackageAvailability = exports.ApiPackageAvailability || (exports.ApiPackageAvailability = {}));
//# sourceMappingURL=D:/a/1/s/base/src/models/api-package-availability.enum.js.map


// WEBPACK FOOTER //
// ./~/@bhtp-client-api/base/src/models/api-package-availability.enum.js